(function () {
  function initFastDelivery(sectionId) {
    var dataEl = document.getElementById('FastDeliveryVariants-' + sectionId);
    if (!dataEl) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var variants = data.variants;
    if (!variants || !variants.length) return;

    var lastSelectedValues = [];

    function getVariantSelects() {
      return document.getElementById('variant-selects-' + sectionId);
    }

    function getSelectedValues() {
      var vs = getVariantSelects();
      if (!vs) return [];
      return Array.from(vs.querySelectorAll('fieldset')).map(function (fs) {
        var checked = fs.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    function isInStock(v) {
      if (!v.available) return false;
      if (v.mgmt !== 'shopify') return false;
      if (v.qty <= 0) return false;
      return true;
    }

    function updateIndicators(selectedValues) {
      var vs = getVariantSelects();
      if (!vs) return;
      vs.querySelectorAll('fieldset').forEach(function (fieldset, levelIndex) {
        fieldset.querySelectorAll('input[type="radio"]').forEach(function (input) {
          var label = input.nextElementSibling;
          if (!label || label.tagName.toLowerCase() !== 'label') {
            label = vs.querySelector('label[for="' + input.id.trim() + '"]');
          }
          if (!label) return;
          var indicator = label.querySelector('.fast-delivery-indicator');
          if (!indicator) return;

          var hasFastDelivery = variants.some(function (v) {
            if (!isInStock(v)) return false;
            if (v['option' + (levelIndex + 1)] !== input.value) return false;
            for (var i = 0; i < levelIndex; i++) {
              if (selectedValues[i] && v['option' + (i + 1)] !== selectedValues[i]) return false;
            }
            return true;
          });

          indicator.style.display = hasFastDelivery ? '' : 'none';
        });
      });
    }

    function updateBadge(selectedValues) {
      var vs = getVariantSelects();
      if (!vs) return;
      var numLevels = vs.querySelectorAll('fieldset').length;
      if (selectedValues.filter(Boolean).length < numLevels) return;

      var selected = variants.find(function (v) {
        return selectedValues.every(function (val, i) {
          return val === v['option' + (i + 1)];
        });
      });

      var sectionEl = document.getElementById('shopify-section-' + sectionId);
      if (!sectionEl) return;

      var showBadge = selected && isInStock(selected);
      sectionEl.querySelectorAll('.fast-delivery-badge').forEach(function (badge) {
        badge.style.display = showBadge ? '' : 'none';
      });
    }

    function applyDeliveryDate(selectedValues) {
      if (!data.fastMinDate) return;
      var vs = getVariantSelects();
      if (!vs) return;
      var numLevels = vs.querySelectorAll('fieldset').length;
      if (selectedValues.filter(Boolean).length < numLevels) return;

      var selected = variants.find(function (v) {
        return selectedValues.every(function (val, i) {
          return val === v['option' + (i + 1)];
        });
      });
      if (!selected) return;

      // Per-variant SLA (e.g. Carlton Recliner 86Rasta:beige / 86EL:imperial sand) falls back to the product-level SLA
      var slaMin = selected.slaMinDate || data.slaMinDate;
      var slaMax = selected.slaMaxDate || data.slaMaxDate;
      var newText = isInStock(selected)
        ? data.fastMinDate + ' - ' + data.fastMaxDate
        : slaMin + ' - ' + slaMax;

      var el = document.querySelector('[data-delivery-date]');
      if (!el) return;

      if (el.textContent.trim() !== newText) {
        el.textContent = newText;
      }
    }

    function updateAll() {
      lastSelectedValues = getSelectedValues();
      updateIndicators(lastSelectedValues);
      updateBadge(lastSelectedValues);
      applyDeliveryDate(lastSelectedValues);
    }

    var sectionEl = document.getElementById('shopify-section-' + sectionId) || document.body;
    if (data.fastMinDate) {
      var debounceTimer = null;
      new MutationObserver(function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          updateBadge(lastSelectedValues);
          applyDeliveryDate(lastSelectedValues);
        }, 50);
      }).observe(sectionEl, { childList: true, subtree: true });
    }

    document.addEventListener('change', function (e) {
      if (!e.target || e.target.type !== 'radio') return;
      var vs = getVariantSelects();
      if (!vs || !vs.contains(e.target)) return;
      updateAll();
    });

    updateAll();
  }

  document.querySelectorAll('[id^="FastDeliveryVariants-"]').forEach(function (el) {
    initFastDelivery(el.id.replace('FastDeliveryVariants-', ''));
  });
})();
